var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "card mt-2 shadow-sm"
  }, [_c('div', {
    staticClass: "card-header border-0"
  }, [_c('b-form-checkbox', [_vm._v(" 一般宅配(2) ")])], 1), _c('div', {
    staticClass: "products"
  }, _vm._l(_vm.products, function (p) {
    return _c('div', {
      key: p.name,
      staticClass: "products__item p-2 py-3"
    }, [_c('div', {
      staticClass: "products__item__check ml-2"
    }, [_c('b-form-checkbox')], 1), _c('div', {
      staticClass: "products__item__photo product__photo"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": "https://picsum.photos/200?".concat(Math.random())
      }
    })]), _c('div', {
      staticClass: "\n            products__item__title\n            product__title\n            d-inline-block\n            text-truncate\n          "
    }, [_vm._v(" " + _vm._s(p.title) + " ")]), _c('div', {
      staticClass: "products__item__price"
    }, [_c('span', {
      staticClass: "oprice mr-1"
    }, [_vm._v(_vm._s(p.oprice))]), _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(p.price))])]), _c('div', {
      staticClass: "products__item__quantity"
    }, [_c('b-form-spinbutton', {
      staticClass: "mt-2",
      attrs: {
        "size": "sm",
        "inline": "",
        "min": "1"
      },
      model: {
        value: p.quantity,
        callback: function callback($$v) {
          _vm.$set(p, "quantity", $$v);
        },
        expression: "p.quantity"
      }
    })], 1), _c('div', {
      staticClass: "products__item__promo mt-3 d-flex align-items-center"
    }, [_c('svg', {
      attrs: {
        "width": "16",
        "height": "16",
        "viewBox": "0 0 16 16",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('circle', {
      attrs: {
        "cx": "8",
        "cy": "8",
        "r": "8",
        "fill": "#FF1744"
      }
    }), _c('path', {
      attrs: {
        "d": "M7.30511 3.3051C7.50046 3.10975 7.76542 3 8.04168 3C8.31795 3 8.5829 3.10975 8.77825 3.3051C8.9736 3.50045 9.08335 3.7654 9.08335 4.04167V8.20833C9.08335 8.4846 8.9736 8.74955 8.77825 8.9449C8.5829 9.14025 8.31795 9.25 8.04168 9.25C7.76542 9.25 7.50046 9.14025 7.30511 8.9449C7.10976 8.74955 7.00002 8.4846 7.00002 8.20833V4.04167C7.00002 3.7654 7.10976 3.50045 7.30511 3.3051Z",
        "fill": "white"
      }
    }), _c('path', {
      attrs: {
        "d": "M8.90627 11.7917C8.94569 11.8497 8.97722 11.9128 9.00002 11.9792C9.0373 12.037 9.06542 12.1002 9.08335 12.1667C9.08846 12.236 9.08846 12.3056 9.08335 12.375C9.08171 12.5111 9.05339 12.6456 9.00002 12.7708C8.95323 12.9001 8.87859 13.0175 8.78139 13.1147C8.68418 13.2119 8.56678 13.2866 8.43752 13.3333C8.31283 13.3884 8.17801 13.4169 8.04168 13.4169C7.90536 13.4169 7.77054 13.3884 7.64585 13.3333C7.51658 13.2866 7.39919 13.2119 7.30198 13.1147C7.20477 13.0175 7.13013 12.9001 7.08335 12.7708C7.02997 12.6456 7.00166 12.5111 7.00002 12.375C6.99922 12.2379 7.0255 12.102 7.07734 11.9751C7.12918 11.8482 7.20556 11.7328 7.3021 11.6354C7.40335 11.5434 7.51962 11.4694 7.64585 11.4167C7.83555 11.3369 8.04463 11.3151 8.2467 11.354C8.44877 11.393 8.63478 11.4909 8.78127 11.6354L8.90627 11.7917Z",
        "fill": "white"
      }
    })]), _c('span', {
      staticClass: "text-danger mx-1"
    }, [_vm._v(" 未符合 ")]), _c('span', {
      staticClass: "table-danger px-2 py-1 rounded rounded-1"
    }, [_vm._v("咖啡周邊買2件打8折")])])]);
  }), 0)]), _c('div', {
    staticClass: "card mt-2 d-block shadow-sm"
  }, [_c('div', {
    staticClass: "card-header border-0"
  }, [_vm._v("加價購")]), _c('swiper', {
    staticClass: "product-carousel",
    attrs: {
      "options": {
        slidesPerView: 'auto',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  }, [_vm._l(_vm.additions, function (p) {
    return _c('swiper-slide', {
      key: p.name,
      staticClass: "product-carousel__item p-2 py-3 d-flex flex-column"
    }, [_c('div', {
      staticClass: "product__photo"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": "https://picsum.photos/200?".concat(Math.random())
      }
    })]), _c('div', {
      staticClass: "product-carousel__item__title product__title"
    }, [_vm._v(" " + _vm._s(p.title) + " ")]), _c('div', {
      staticClass: "\n          product-carousel__item__price\n            flex-fill\n            d-flex\n            flex-column\n            justify-content-end\n          "
    }, [_c('div', {
      staticClass: "oprice mr-1"
    }, [_vm._v(_vm._s(p.oprice))]), _c('div', {
      staticClass: "price"
    }, [_vm._v(_vm._s(p.price))])]), _c('button', {
      staticClass: "p-2 btn product-carousel__item__purchase mt-2"
    }, [_vm._v("加購")])]);
  }), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _vm._m(0), _c('div', {
    staticClass: "sticky-bottom d-flex justify-content-between align-items-center p-3"
  }, [_vm._m(1), _c('div', {
    staticClass: "flex-fill pl-3"
  }, [_c('router-link', {
    staticClass: "btn w-100 btn-primary btn-lg",
    attrs: {
      "to": {
        name: 'LiffShopCheckout'
      }
    }
  }, [_vm._v(" 結帳(2) ")])], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card mt-2 d-block shadow-sm"
  }, [_c('div', {
    staticClass: "card-header border-0"
  }, [_vm._v("結帳明細")]), _c('div', {
    staticClass: "p-3 detail"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('span', [_vm._v("商品總金額")]), _c('span', {
    staticClass: "text-dark"
  }, [_vm._v("$ 4,160")])]), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('span', [_vm._v("活動折抵")]), _c('span', {
    staticClass: "text-dark"
  }, [_vm._v("– $ 600")])])]), _c('div', {
    staticClass: "d-flex justify-content-between card-header border-0"
  }, [_c('span', [_vm._v("總金額")]), _c('span', {
    staticClass: "price"
  }, [_vm._v("NT$ 3,560")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" 總金額"), _c('span', {
    staticClass: "price"
  }, [_vm._v("$ 3,560")])]), _c('div', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "mr-2"
  }, [_vm._v("總額 $4,160")]), _c('span', [_vm._v("折抵 $600")])])]);
}]

export { render, staticRenderFns }